import React, { useState } from 'react';
import { LoadingAnimation } from '../../common/components/Utilities';

function SicknessPdf({ sicknessIds }) {
  const [loading, setLoading] = useState(false);
  let downloadInterval;
  let sicknessIdsInterval;

  const downloadPdf = async () => {
    setLoading(true);

    const sicknessId = sicknessIdsInterval.pop();
    const downloadUrl = `/sickness/${sicknessId}/download`;

    window.open(downloadUrl, '_blank');

    if (sicknessIdsInterval.length === 0) {
      setLoading(false);
      clearInterval(downloadInterval);
    }
  };

  const handleClick = async () => {
    sicknessIdsInterval = [...sicknessIds];
    downloadInterval = setInterval(downloadPdf, 300);
  };

  return (
    <>
      <LoadingAnimation loading={loading} />
      <button disabled={!sicknessIds.length} type="button" onClick={handleClick} className="float-right mr-2 btn btn-outline-primary" title={sicknessIds.length ? (`Will download ${sicknessIds.length} sickness(es) in PDF format`) : 'Please use the filters above before downloading all as PDFs'}>
        <i className="fa fa-download" />
        {' '}
        Download all as PDF
      </button>
    </>
  );
}

export default SicknessPdf;
